import { useEffect } from "react"

import useLocale from "hooks/useLocale"

export const formatDateSeries = (data, offset = 0) => {
  return data.map((d) => {
    return [new Date(d.date).getTime() + offset, d.revenue]
  })
}

const SUPPORTED_LOCALES = ["en", "de"]

const MONTH_SAMPLES = [...Array(12).keys()].map((month) =>
  Date.UTC(2021, month, 1)
)

const WEEKDAY_SAMPLES = [...Array(7).keys()].map((day) =>
  Date.UTC(2021, 7, 1 + day)
)

const namesFor = (locale, samples, options) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    ...options,
    timeZone: "UTC"
  })

  return samples.map((sample) => formatter.format(sample))
}

const LOCALES = SUPPORTED_LOCALES.map((locale) => ({
  name: locale,
  options: {
    months: namesFor(locale, MONTH_SAMPLES, { month: "long" }),
    shortMonths: namesFor(locale, MONTH_SAMPLES, { month: "short" }),
    days: namesFor(locale, WEEKDAY_SAMPLES, { weekday: "long" }),
    shortDays: namesFor(locale, WEEKDAY_SAMPLES, { weekday: "short" })
  }
}))

export const apexChartLocale = (locale) => ({
  locales: LOCALES,
  defaultLocale: locale
})

export const useApexChartLocale = (chartRef, options) => {
  const locale = useLocale()

  useEffect(() => {
    const chart = chartRef.current?.chart

    if (!chart) {
      return
    }

    chart.setLocale(locale)
    chart.updateOptions(
      { ...options, chart: { defaultLocale: locale } },
      false,
      false
    )
  }, [chartRef, locale, options])
}
